<div class="wrapper">
  <h2 class="title">Telegram</h2>
  <div class="container">
    <app-telegram-accounts
      (selectAccount)="selectAccount()"
    />
    @if (selectedAccount) {
      <app-telegram-bloggers
        [chats]="chats"
        [selectedChat]="selectedChat"
        [isVisibleBloggers]="isVisibleBloggers"
        (handleSelectChat)="handleSelectChat($event)"
        (toggleBlogger)="toggleBlogger()"
      />
    }
    <app-telegram-chat-window
      [selectedChat]="selectedChat"
      [messages]="messages"
      (sendMessage)="sendMessage($event)"
    />
  </div>
</div>
